import { Component } from 'react';
import { Navbar } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { CONSTANTS } from "../config/Constants";
import { ReactComponent as Logo } from "../design/controller.svg";
import ApplicationState from "../mobx/ApplicationState";

import "./AppHeader.scss";

class AppHeader extends Component {
    doClick(event) {
        if (window.innerWidth < CONSTANTS.MobileCollapseWidth && !window.location.pathname.startsWith('/play/')) {
            ApplicationState.toggleNavIsOpen();
            event.preventDefault();
        }
    }

    render() {
        return (
            <header className="app-header">
                <Navbar bg="dark" variant="dark">
                    <LinkContainer to="/" onClick={event => this.doClick(event)}>
                        <Navbar.Brand href="/">
                            <Logo alt="controller" />{" "}
                            {CONSTANTS.ApplicationName}
                        </Navbar.Brand>
                    </LinkContainer>
                </Navbar>
            </header>
        );
    }
}

export default AppHeader;
